import { TextFilterType } from '../../../../../types';
import { ProjectStatus } from '../../../../../main/projects/projectsTypes';

export type UniversalFilterProjectStatusStatus = ProjectStatus;

export const enum UniversalFilterProjectStatusModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterProjectStatusValue = TextFilterType;

export type UniversalFilterProjectStatusFilterState = {
  mode: UniversalFilterProjectStatusModes;
  statuses?: UniversalFilterProjectStatusStatus[];
};

export type UniversalFilterProjectStatusOnFilterStateChange = (
  state: UniversalFilterProjectStatusFilterState
) => void;

export type UniversalFilterProjectStatusOnChange = (
  value?: UniversalFilterProjectStatusValue
) => void;
